module.exports = __webpack_public_path__ + "img/Badge_Soc2Type2.97f71e19.svg";